import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/site/Logo";
import { api, errMsg } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("caf_token", data.token);
      nav("/admin");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };
  const cls = "h-12 rounded-none border-white/15 bg-[#111317] text-zinc-100 focus-visible:ring-[var(--acid)]";

  return (
    <main className="grain relative flex min-h-screen flex-col bg-[#090A0C] px-5 text-zinc-100" data-testid="admin-login-page">
      <header className="py-5"><Link to="/" data-testid="admin-login-logo-link"><Logo /></Link></header>
      <div className="m-auto w-full max-w-md py-16">
        <p className="eyebrow mb-4 text-acid">Owner access</p>
        <h1 className="font-display text-6xl uppercase leading-[0.9] text-zinc-50">Back of <span className="font-serif-i normal-case text-acid">house.</span></h1>
        <form onSubmit={submit} className="mt-10 flex flex-col gap-5" data-testid="admin-login-form">
          <div className="flex flex-col gap-2">
            <Label htmlFor="em" className="eyebrow">Email</Label>
            <Input id="em" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={cls} data-testid="admin-login-email-input" required />
          </div>
          <div className="flex flex-col gap-2">
            <Label htmlFor="pw" className="eyebrow">Password</Label>
            <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={cls} data-testid="admin-login-password-input" required />
          </div>
          {err && <p className="text-sm text-red-400" data-testid="admin-login-error">{err}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-submit-button"
            className="mt-2 flex h-12 items-center justify-center rounded-full bg-acid font-bold text-black transition-transform duration-300 hover:scale-[1.02] disabled:opacity-50">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign in"}
          </button>
        </form>
      </div>
    </main>
  );
}
